import { render, staticRenderFns } from "./SocialSummaryPostList.vue?vue&type=template&id=747f455a&"
import script from "./SocialSummaryPostList.vue?vue&type=script&lang=js&"
export * from "./SocialSummaryPostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('747f455a')) {
      api.createRecord('747f455a', component.options)
    } else {
      api.reload('747f455a', component.options)
    }
    module.hot.accept("./SocialSummaryPostList.vue?vue&type=template&id=747f455a&", function () {
      api.rerender('747f455a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialSummaryPostList.vue"
export default component.exports